import axiosClient from "./axiosClient";

// Check users
export const checkIfUsersExist = () => axiosClient.get("/users/check");

// Register
export const registerUser = (userData) => axiosClient.post("/users/register", userData);

// Login
export const loginUser = (credentials) => axiosClient.post("/users/login", credentials);

// Forgot Password
export const sendResetEmail = (data) => axiosClient.post("/users/forgot-password", data); // { email }

// Reset Password
export const resetPassword = (data) => axiosClient.post("/users/reset-password", data); // { userId, token, password }
